import { ReduxComponentInterface } from 'edocatbase/Global';
import { ControlInterface } from 'edocatbase/Form';
import {  FormHelperText  } from "@mui/material";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TableInner from './TableInner';
import FormModal from './FormModal';
import { Dispatch } from 'redux';
import { extractNoderefsFromFormTableFieldDataJSON, substituteNodeRefsByLabel } from '../../../../../utils/tableAsyncCells';
import { fetchObjectsToCache } from '../../../../../actions/objectCache';
import { without } from 'ramda';
import DeleteTableItemModal from './DeleteTableItemModal';
import { toggleModal } from '../../../../ModalTest/actions';


interface TableProps extends ReduxComponentInterface, ControlInterface {
	isTableModalOpen: boolean;
	formInstanceId: string;
	params: any;
	formModal: any;
	view: boolean;
	error: any;
	mandatory: boolean;
	usedObjects: any;
	deleteTableItemModal: any;
}

class Table extends React.PureComponent<TableProps> {
	static defaultProps: {
		view: false;
	};

	componentDidMount(): void {
		const { actions, value, usedObjects } = this.props;
		const missing = without(Object.keys(usedObjects), extractNoderefsFromFormTableFieldDataJSON(value ?? []));
		if (missing.length > 0) {
			actions.fetchObjectsToCache(missing);
		}
	}

	onLinkClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, name, formInstanceId } = this.props;
		actions.toggleModal(true, name, null, formInstanceId);
	};

	render() {
		const {
			label,
			name,
			formInstanceId,
			value,
			params,
			formModal,
			view,
			error,
			mandatory,
			usedObjects,
			deleteTableItemModal,
		} = this.props;

		const dislplayValues = substituteNodeRefsByLabel(value, params.tableHeaders, usedObjects, this.props);

		return (
			<div className={`form-row row-${name}`}>
				<TableInner {...{ name, value, wholeTableDislplayValues: dislplayValues, params, formInstanceId, view, label, error, mandatory }} />
				<FormHelperText error={error?true:false}>{error}</FormHelperText>
				{formModal?.isOpen && <FormModal {...{ name, value, dislplayValues, params, formModal, formInstanceId }} />}
				{deleteTableItemModal?.isOpen && <DeleteTableItemModal {...{name, formInstanceId}}/>}
			</div>
		);
	}
}

const mapStateToProps = (state: any, props: any) => {
	const formModal = state?.[props.formInstanceId]?.formModal?.[`form${props.name}`] || {};
	//const error = state?.[props.formInstanceId]?.form?.error;
	const mandatory = state?.[props.formInstanceId]?.form?.fields?.[props.name]?.mandatory;
	const usedObjects = state?.cacheReducer?.usedObjects || {};
	const deleteTableItemModal = state?.[props.formInstanceId]?.formModal?.[`${props.name}deleteTableItemModal`] || {};

	return {
		usedObjects,
		formModal,
		mandatory,
		deleteTableItemModal
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ toggleModal, fetchObjectsToCache }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Table);
